module.exports = __webpack_public_path__ + "img/R8804-PX.40b41a9d.jpg";